module.exports = "data:image/svg+xml;base64,PHN2ZyBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAyMjIuNiAyMjciIHZpZXdCb3g9IjAgMCAyMjIuNiAyMjciIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0ibTEwNS4xIDEyMS45Yy0zMS41LTMxLjUtNDAtNzcuMS0yNi0xMTYuNS0xNS4yIDUuNC0yOS43IDEzLjgtNDEuOSAyNi00My44IDQzLjgtNDMuOCAxMTQuNyAwIDE1OC40IDQzLjcgNDMuNyAxMTQuNiA0My44IDE1OC40IDAgMTIuMi0xMi4yIDIwLjYtMjYuNiAyNi00MS45LTM5LjQgMTQtODUgNS42LTExNi41LTI2eiIgZmlsbD0iI2ZmZiIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./static/images/weather-icons/Moon-WHITE.svg
// module id = 1821
// module chunks = 1